'use client';

import { FC, PropsWithChildren } from 'react';
import { TransactionsProvider } from './_context/TransactionsContext';

const TransactionsLayout: FC<PropsWithChildren<unknown>> = ({ children }) => (
  <TransactionsProvider>{children}</TransactionsProvider>
);

export default TransactionsLayout;
